"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeToolNameSchema = exports.toolNameChangeSchema = exports.TOOL_NAME_MAX = void 0;
exports.toolNameKey = toolNameKey;
exports.toolNamesOf = toolNamesOf;
const schemas_1 = require("./schemas");
// Owner's evening review 2026-11-01, Request a hire item 7 (DECISIONS-LOG 2026-11-02 Q4 a): box 1 "Tools or systems" of the
// Ideal candidate profile learns from what is typed. A tool typed once becomes a pick next time; HR and admins delete or merge
// misspelt entries from Admin settings → Tools and systems (ADMIN-19, F19.14). Requesters only pick or type.
/** As long as box 1's tool cell allows (`toolRowSchema`). */
exports.TOOL_NAME_MAX = 120;
/**
 * Two spellings are the same tool when they match ignoring case and spacing: "Google Sheets", "google  sheets " and
 * "GOOGLE SHEETS" are one entry. The list's uniqueness, a merge's rewrite and the "used in" counts all use this one key.
 */
function toolNameKey(name) {
    return name.replace(/\s+/g, ' ').trim().toLowerCase();
}
/** The tool names box 1 of a profile holds, blanks left out, each spelling once. */
function toolNamesOf(profile) {
    if (profile === null)
        return [];
    const byKey = new Map();
    for (const row of profile.tools) {
        const name = row.tool.replace(/\s+/g, ' ').trim();
        if (name !== '' && !byKey.has(toolNameKey(name)))
            byKey.set(toolNameKey(name), name);
    }
    return [...byKey.values()];
}
exports.toolNameChangeSchema = schemas_1.versionedSchema;
exports.mergeToolNameSchema = schemas_1.versionedSchema.extend({
    /** The entry that stays; this one is hidden and reads as it from now on. */
    intoId: schemas_1.uuidSchema,
});
//# sourceMappingURL=tool-names.js.map